import React, { useRef, useEffect, useState } from 'react';
import LogoImg from '../../../assets/img/logo/Save-Logo-White-2.webp';
import LogoImgDark from '../../../assets/img/logo/Save-Logo-Blue-2.webp';
import { useThemeMode } from '../../../context/contextTheme';

const Logo = () => {
  const containerRef = useRef(null);
  const [height, setHeight] = useState(30); // default height
  const { mode } = useThemeMode();

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const newHeight = containerRef.current.clientHeight;
        setHeight(newHeight);
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    updateHeight(); // initial height set

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div className="flex-grow-1 px-4 d-flex align-items-center" ref={containerRef}>
      <a href="/save/dashboard">
        <img
          src={mode === 'light' ? LogoImgDark : LogoImg}
          alt="SAVE"
          style={{ 
            height: `${height}px`,
            width: 'auto', 
            objectFit: 'contain',
            transition: 'all 0.3s ease',
          }}
        />
      </a>
    </div>
  );
};

export default Logo;